import { EmployeeRequestStatus } from '@/store/share-now-pass/share-now-pass.model';

export interface DriverListMeta {
  total: number;
}

export interface DriverTabStore {
  page: number;
  drivers: Drivers;
  tab?: DriverTab;
}

export interface DriverManagementState {
  drivers: Driver[];
  meta: DriverListMeta;
  pendingTotal: number;
  activeTotal: number;
  activeDriverIdMenuAction: string;
  invitationUrl: string;
  [DriverTab.PENDING]?: DriverTabStore;
  [DriverTab.INACTIVE]?: DriverTabStore;
  [DriverTab.ACTIVE]?: DriverTabStore;
}

export enum CompanyDriverStatus {
  INVITATION_SENT = 'INVITATION_SENT',
  INVITATION_EXPIRED = 'INVITATION_EXPIRED',
  INVITATION_DECLINED = 'INVITATION_DECLINED',
  INVITATION_ACCEPTED = 'INVITATION_ACCEPTED',
  DRIVER_INACTIVE = 'DRIVER_INACTIVE',
  DRIVER_REQUEST_PENDING = 'DRIVER_REQUEST_PENDING',
}

export interface DriverListFilterItem {
  key: CompanyDriverStatus;
  label: string;
  value: boolean;
}

export interface DriverMapped {
  id: string;
  href: string;
  status: CompanyDriverStatus;
  email: string;
  businessEmail?: string;
  message?: string;
  firstName?: string;
  lastName?: string;
  showDeletePanel?: boolean;
  shareNowPassStatus: EmployeeRequestStatus;
  customerId?: number;
}

export enum AcceptRejectUseCaseIdentifier {
  ACCEPT = 'accept',
  REJECT = 'reject',
}

export interface BaseDriver {
  email: string;
  firstName?: string;
  lastName?: string;
  message?: string;
}

export interface NewDriver extends BaseDriver {}
export interface Driver extends BaseDriver {
  id: string;
  customerId: number;
  customerUuid: string;
  status: CompanyDriverStatus;
  href: string;
  statusUpdatedAt: Date;
  businessEmail?: string;
  costCenters?: string[];
  memberName?: string;
}

export interface Drivers {
  data: Driver[];
  meta: DriverListMeta;
}

export interface DriverInvitationToken {
  data: {
    createdAt: Date;
    href: string;
    id: string;
    token: string;
  };
  meta: {
    invitationUrl: string;
  };
}

// Driver resource for company drivers, not for admins
interface DriverResource {
  href: string;
  customerId: number;
  status: string;
  email?: string;
  statusUpdatedAt?: string;
}

export enum DriverTab {
  PENDING = 'pending',
  ACTIVE = 'active',
  INACTIVE = 'inactive',
}

export enum DriverRequestAction {
  ACCEPT = 'accept',
  REJECT = 'reject',
  UPDATE = 'update',
}

export enum CompanyType {
  CENTRAL = 'CENTRAL',
  NON_CENTRAL = 'NON_CENTRAL',
}

export interface DriverMetadata {
  companyType: CompanyType;
}

export interface DriverResponse {
  data: DriverResource;
  meta?: DriverMetadata;
}

export interface RequestTokenValidation {
  data: {
    createdAt: Date;
    href: string;
    id: string;
    token: string;
  };
  meta: {
    driverStatus: CompanyDriverStatus | null;
    companyName: string;
    companyType: CompanyType;
  };
}

export interface DriverGetParams {
  customerId?: number;
  limit?: number;
  skip?: number;
  status?: string;
  search?: string;
}
